import $ from "./adminBase";

export default {
    addMenu( data ) {
        return $.post("/system/menu", data );
    },

    updateMenu( data ) {
        return $.put("/system/menu", data );
    },

    menuList( data ) {
        return $.get("/system/menu/list", data );
    },

    

    menuListTree( data ) {
        return $.get("/system/menu/treeselect", data );
    },

    menuDataById( id ) {
        return $.get("/system/menu/"+id );
    },

    delMenu( id ){
        return $.delete("/system/menu/"+id );
    },

    
};